import { DATE_FORMATS } from '../../constants';
import { format } from 'date-fns/esm';

const { ISO_8601 } = DATE_FORMATS;

export const toIso8601 = date => format(date, ISO_8601);

export function stringToDate(dateStr, formatDate = ISO_8601) {
  return dateStr ? format(dateStr, formatDate) : dateStr;
}
